module.exports = __webpack_public_path__ + "static/media/teabag.c122a025.svg";